import { useContext, useState } from "react";
import TextEditor from "../../components/Table/TextEditor";
import { context } from "../../context/authContext";
import useActions from "./acciones";
import { useNavigate } from "react-router-dom";
import useApi from "../../helpers/api";

export default function useColumns(setSelectedRow,setModalOpen,empresas) {
  const { user } = useContext(context);
  const { handleDelete } = useActions();
  const url = process.env.REACT_APP_ENVIRONMENT === "local" ? `http://localhost:${process.env.REACT_APP_PORT}` : process.env.REACT_APP_API_URL;
  const userRoles = user?.rol || [];
  const permisos = userRoles.find((role) => role.nombre === "Salas")?.permiso || [];
  const isEditable = permisos.includes("editar");
  const canDelete = permisos.includes("borrar");
  const navigate = useNavigate();
  const api = useApi();

  let empresaOptions = {};
  for(const empresa of empresas){
    empresaOptions[empresa.id] = empresa.nombre;
  }

  const ImageUploadRenderer = (params) => {
    const [image, setImage] = useState(url+params.data.layout || null);

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            let formData = new FormData();
            formData.id = params.data.id
            formData.append("image", file);
            formData.append("empresa", Object.keys(empresaOptions).find(id => empresaOptions[id] === params.data.empresa));
            const reader = new FileReader();
            reader.onloadend = () => {
                params.setValue(reader.result);
            };
            reader.readAsDataURL(file);
            const response = await api.updateSala(formData);
            setImage(url+response.layout)
        }
    };

    return (
        <div style={{ textAlign: "center" }}>
            {image && <img src={image} alt="Uploaded" style={{ width: 50, height: 50 }} />}
            <input type="file" accept="image/*" onChange={handleImageUpload} style={{ marginTop: 5 }} />
        </div>
    );
  };

  return [
    { field: "id", sort: "asc", cellClass: "d-flex align-items-center" },
    ...["nombre","createdAt"].map((field) => ({
      field,
      flex: field === 'nombre' ? 1 : 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      autoHeight: true,
      editable: field === "createdAt" ? false : isEditable,
      valueFormatter: field === "createdAt" ? (params) =>{
        let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
        ${new Date(params.value).toLocaleTimeString("en-GB")}` 
        return date }: undefined,
      tooltipValueGetter: (params) => params.data?.[`tooltipError${field}`] || "",
      cellClassRules: {
        "is-invalid": (params) => !!params.data?.[`tooltipError${field}`],
        "is-valid": (params) => !!params.data?.[`isValid${field}`],
      },
    })),
    {
      field: "empresa",
      flex: 2,
      autoHeight: true,
      cellClass: "d-flex align-items-center",
      cellEditor: "agSelectCellEditor",
      editable: (params) => params.data.rol !== "superadmin" && isEditable,
      cellEditorParams: { values: Object.keys(empresaOptions) },
      valueFormatter: (params) => empresaOptions[params.value] || params.value,
    },
    {
      field: "layout",
      flex: 4,
      autoHeight: true,
      cellRenderer: ImageUploadRenderer,
  },
    isEditable && {
      field: "asientos",
      flex: 1,
      autoHeight: true,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button onClick={() => navigate(`/salas/${data.data.id}`)} className="btn btn-primary px-2 py-1">
          Editar
        </button>
      ),
    },
    canDelete && {
      field: "eliminar",
      flex: 2,
      autoHeight: true,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button onClick={() => handleDelete(data, setSelectedRow,setModalOpen)} className="btn btn-primary px-2 py-1">
          🗑️ Eliminar
        </button>
      ),
    },
  ].filter(Boolean);
}
